export default __webpack_public_path__ + "static/media/etf.afb68c06.svg";